module.exports = __webpack_public_path__ + "img/pause-white.2df5158a.svg";